import { connect } from 'react-redux'
import React, { Component } from 'react'
import Tool from '../app/tools/Tool'

class ToolContainer extends Component {
  render() {
    const { params, location, userName } = this.props
    if ( location.pathname.includes('trim-video')) {
      params.view = 'trim'
    } else if ( location.pathname.includes('mute-video')) {
      params.view = 'mute'
    } else if ( location.pathname.includes('crop-video')) {
      params.view = 'crop'
    } else if ( location.pathname.includes('compress-video')) {
      params.view = 'compress'
    } else if ( location.pathname.includes('embed-video')) {
      params.view = 'embed'
    } else if ( location.pathname.includes('rotate-video')) {
      params.view = 'rotate'
    } else if ( location.pathname.includes('upload-video')) {
      params.view = 'upload'
    }

    return <Tool viewParams={{ ...params, query: location.query }} />
  }
}

export default connect()(ToolContainer)
